module.exports = __webpack_public_path__ + "static/002_conditioned-nature-97098c83ee3990b4fc19222c7311a8db.gif";